export default {
    DECIMAL_COMMA: 'de',
    DECIMAL_PERIOD: 'en'
};
